"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagementHeader = exports.SolverHeader = exports.HeaderContext = void 0;
var HeaderContext = /** @class */ (function () {
    function HeaderContext(header) {
        this.header = header;
    }
    HeaderContext.prototype.createHeader = function (key, strategy) {
        return this.header.createHeader(key, strategy);
    };
    return HeaderContext;
}());
exports.HeaderContext = HeaderContext;
var SolverHeader = /** @class */ (function () {
    function SolverHeader() {
    }
    SolverHeader.prototype.createHeader = function (apiKey, strategy) {
        if (strategy) {
            return {
                Authorization: "Bearer " + apiKey,
                "X-Strategy": strategy,
                "Content-Type": 'application/json'
            };
        }
        return {
            Authorization: "Bearer " + apiKey,
            "Content-Type": 'application/json'
        };
    };
    return SolverHeader;
}());
exports.SolverHeader = SolverHeader;
var ManagementHeader = /** @class */ (function () {
    function ManagementHeader() {
    }
    ManagementHeader.prototype.createHeader = function (managementKey) {
        return {
            Authorization: "Bearer " + managementKey,
            "Content-Type": 'application/json'
        };
    };
    return ManagementHeader;
}());
exports.ManagementHeader = ManagementHeader;
